import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, Package, Video, Handshake, Megaphone, Globe, CheckCircle, XCircle, ChevronDown, Play, ArrowRight, MessageCircle, Search, FileText, Rocket } from 'lucide-react';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
export function CoachingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/3zsvshqebj.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      if (document.head.contains(playerScript)) document.head.removeChild(playerScript);
      if (document.head.contains(embedScript)) document.head.removeChild(embedScript);
    };
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: '¿Cómo funciona el coaching VIP 1:1?',
    a: 'Hacemos un diagnóstico profundo de tu negocio, definimos el plan de acción personalizado y trabajamos juntos en la implementación. La frecuencia y formato de las sesiones se adapta a tu situación específica.'
  }, {
    q: '¿Cuánto tiempo dura el programa?',
    a: 'Depende de tus objetivos y el nivel de acompañamiento que necesitas. Discutimos esto en la llamada inicial para diseñar el plan correcto para ti.'
  }, {
    q: '¿Necesito tener ya un negocio funcionando?',
    a: 'No necesariamente. Trabajo tanto con personas que quieren construir desde cero como con marcas establecidas que quieren escalar. Lo importante es que tengas la mentalidad y el capital para invertir.'
  }, {
    q: '¿Cómo me contacto para empezar?',
    a: 'Simplemente haz clic en el botón de WhatsApp y cuéntame brevemente tu situación. Te responderé personalmente para agendar una llamada de diagnóstico.'
  }];
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc] selection:text-black overflow-x-hidden" data-id="element-1349">
      <VslHeader data-id="element-1350" />

      {/* Scrolling Marquee Banner */}
      <div className="fixed top-[40px] md:top-[48px] left-0 right-0 z-40 bg-[#00f7fc] text-black py-1.5 overflow-hidden border-b border-black/10 shadow-md" data-id="element-1351">
        <div className="whitespace-nowrap flex items-center animate-marquee text-[10px] md:text-xs font-black tracking-widest uppercase" data-id="element-1352">
          <span className="mx-4" data-id="element-1353">+$50M EN RESULTADOS COLECTIVOS</span>
          <span className="mx-2" data-id="element-1354">◆</span>
          <span className="mx-4" data-id="element-1355">
            ECOMMERCE · PRODUCTOS DIGITALES · FUNNELS
          </span>
          <span className="mx-2" data-id="element-1356">◆</span>
          <span className="mx-4" data-id="element-1357">META ADS · YOUTUBE ADS · AFILIADOS</span>
          <span className="mx-2" data-id="element-1358">◆</span>
          <span className="mx-4" data-id="element-1359">PAY PER CALL · MLM · DTC</span>
          <span className="mx-2" data-id="element-1360">◆</span>
          <span className="mx-4" data-id="element-1361">WEBINARS · VSL · RETARGETING</span>
          <span className="mx-2" data-id="element-1362">◆</span>
          <span className="mx-4" data-id="element-1363">ESTRATEGIA PERSONALIZADA 1:1</span>

          {/* Duplicate for seamless loop */}
          <span className="mx-2" data-id="element-1364">◆</span>
          <span className="mx-4" data-id="element-1365">+$50M EN RESULTADOS COLECTIVOS</span>
          <span className="mx-2" data-id="element-1366">◆</span>
          <span className="mx-4" data-id="element-1367">
            ECOMMERCE · PRODUCTOS DIGITALES · FUNNELS
          </span>
          <span className="mx-2" data-id="element-1368">◆</span>
          <span className="mx-4" data-id="element-1369">META ADS · YOUTUBE ADS · AFILIADOS</span>
          <span className="mx-2" data-id="element-1370">◆</span>
          <span className="mx-4" data-id="element-1371">PAY PER CALL · MLM · DTC</span>
          <span className="mx-2" data-id="element-1372">◆</span>
          <span className="mx-4" data-id="element-1373">WEBINARS · VSL · RETARGETING</span>
          <span className="mx-2" data-id="element-1374">◆</span>
          <span className="mx-4" data-id="element-1375">ESTRATEGIA PERSONALIZADA 1:1</span>
        </div>
      </div>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[500px] md:h-[700px] z-0 opacity-40" data-id="element-1376">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-1377" />
      </div>

      <main className="relative z-10 pt-32 md:pt-40 pb-20" data-id="element-1378">
        {/* 2. HERO SECTION */}
        <section className="max-w-4xl mx-auto px-4 text-center mb-20 md:mb-32" data-id="element-1379">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 px-4 py-1.5 rounded-full mb-6" data-id="element-1380">
            <span className="relative flex h-2 w-2" data-id="element-1381">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00f7fc] opacity-75" data-id="element-1382"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00f7fc]" data-id="element-1383"></span>
            </span>
            <span className="text-[#00f7fc] font-bold text-xs uppercase tracking-widest" data-id="element-1384">
              Coaching VIP 1:1 Exclusivo
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-white mb-6" data-id="element-1385">
            Escala Tu Marca Con La Estrategia Exacta Que Generó{' '}
            <span className="text-[#00f7fc]" data-id="element-1386">+$50M</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-base md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed mb-10" data-id="element-1387">
            Un plan de acción 100% personalizado para tu negocio. Ya sea que
            estés construyendo desde cero o escalando una marca establecida,
            trabajo contigo directamente para diseñar e implementar la
            estrategia correcta.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="w-full max-w-md mx-auto mb-12" data-id="element-1388">
            <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-5 px-6 transition-all duration-300 transform hover:scale-[1.03]" style={{
            boxShadow: '0 0 20px rgba(253, 185, 49, 0.25), 0 0 40px rgba(253, 185, 49, 0.1)'
          }} data-id="element-1389">
              <span className="absolute inset-0 rounded-xl animate-pulse" style={{
              boxShadow: '0 0 25px rgba(253, 185, 49, 0.35), 0 0 50px rgba(253, 185, 49, 0.15)'
            }} data-id="element-1390" />
              <MessageCircle className="relative z-10 w-6 h-6" data-id="element-1391" />
              <span className="relative z-10" data-id="element-1392">Contáctame en WhatsApp</span>
              <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-1393">
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] animate-shine" data-id="element-1394" />
              </div>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto border-t border-white/10 pt-8" data-id="element-1395">
            <div data-id="element-1396">
              <p className="text-3xl font-black text-white mb-1" data-id="element-1397">$50M+</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-1398">
                Resultados colectivos
              </p>
            </div>
            <div data-id="element-1399">
              <p className="text-3xl font-black text-white mb-1" data-id="element-1400">10+</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-1401">
                Años de experiencia
              </p>
            </div>
            <div data-id="element-1402">
              <p className="text-3xl font-black text-white mb-1" data-id="element-1403">6</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-1404">
                Áreas de expertise
              </p>
            </div>
          </motion.div>
        </section>

        {/* 3. VIDEO SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 mb-24" data-id="element-1405">
          <div className="text-center mb-8" data-id="element-1406">
            <h2 className="text-2xl md:text-4xl font-black text-white mb-3" data-id="element-1407">
              Mira Este Video Primero
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1408">
              Por Qué Este Coaching Es Diferente
            </p>
          </div>

          <div className="relative bg-gray-900 border border-[#00f7fc]/30 overflow-hidden shadow-2xl rounded-2xl" style={{
          boxShadow: '0 0 10px rgba(0, 247, 252, 0.15), 0 0 30px rgba(0, 247, 252, 0.08)'
        }} data-id="element-1409">
            <style dangerouslySetInnerHTML={{
            __html: `wistia-player[media-id='3zsvshqebj']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/3zsvshqebj/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`
          }} data-id="element-1410" />
            <wistia-player media-id="3zsvshqebj" aspect="1.7777777777777777" data-id="element-1411"></wistia-player>
          </div>
        </motion.section>

        {/* 4. EXPERTISE GRID */}
        <motion.section {...fadeIn} className="max-w-6xl mx-auto px-4 mb-24" data-id="element-1412">
          <div className="text-center mb-12" data-id="element-1413">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1414">
              Áreas de Expertise
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-1415">
              Domino Cada Área Donde Tu Marca Necesita Crecer
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1416">
            {[{
            icon: ShoppingCart,
            title: 'Ecommerce & DTC',
            desc: 'Marcas directas al consumidor, optimización de tiendas, estrategias de retención y escalamiento con paid traffic.'
          }, {
            icon: Package,
            title: 'Productos Digitales',
            desc: 'Creación, lanzamiento y escalamiento de infoproductos, cursos, membresías y software.'
          }, {
            icon: Video,
            title: 'Webinars & VSL Funnels',
            desc: 'Diseño de embudos de alta conversión: webinars en vivo, VSLs, páginas de ventas y secuencias de email.'
          }, {
            icon: Handshake,
            title: 'Afiliados & Pay Per Call',
            desc: 'Redes de afiliados, arbitraje de tráfico, pay per call y modelos de revenue share.'
          }, {
            icon: Megaphone,
            title: 'Meta Ads & YouTube Ads',
            desc: 'Estrategia de campañas, creativos, audiencias, retargeting y optimización de ROAS.'
          }, {
            icon: Globe,
            title: 'MLM & Marketing de Red',
            desc: 'Estrategias de reclutamiento digital, duplicación de equipos y construcción de marca personal para líderes de red.'
          }].map((item, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/10 hover:border-[#00f7fc]/30 transition-all duration-300 group" data-id="element-1417">
                <div className="w-14 h-14 bg-[#00f7fc]/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-1418">
                  <item.icon className="w-7 h-7 text-[#00f7fc]" data-id="element-1419" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-1420">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm" data-id="element-1421">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </motion.section>

        {/* 5. RESULTS SECTION */}
        <motion.section {...fadeIn} className="max-w-5xl mx-auto px-4 mb-24" data-id="element-1422">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-1423">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00f7fc] to-blue-600" data-id="element-1424"></div>

            <h2 className="text-2xl md:text-4xl font-black text-white text-center mb-12" data-id="element-1425">
              +$50M Generados En Múltiples Industrias
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1426">
              <div className="text-center" data-id="element-1427">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1428">$50M+</p>
                <p className="text-white font-bold mb-1" data-id="element-1429">
                  Generados colectivamente
                </p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1430">
                  En todas las áreas combinadas
                </p>
              </div>
              <div className="text-center" data-id="element-1431">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1432">10+</p>
                <p className="text-white font-bold mb-1" data-id="element-1433">Años de experiencia</p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1434">
                  En marketing digital
                </p>
              </div>
              <div className="text-center" data-id="element-1435">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1436">6</p>
                <p className="text-white font-bold mb-1" data-id="element-1437">Modelos de negocio</p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1438">
                  Dominados y probados
                </p>
              </div>
              <div className="text-center" data-id="element-1439">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1440">1:1</p>
                <p className="text-white font-bold mb-1" data-id="element-1441">
                  Coaching personalizado
                </p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1442">
                  Plan único para tu negocio
                </p>
              </div>
            </div>
          </div>

          {/* Revenue Growth Screenshot */}
          <div className="mt-12 max-w-2xl mx-auto" data-id="element-1443">
            <div className="text-center mb-6" data-id="element-1444">
              <p className="text-[#00f7fc] font-bold text-sm uppercase tracking-widest mb-2" data-id="element-1445">
                Crecimiento Real — Mis Propios Números
              </p>
              <p className="text-gray-400 text-base" data-id="element-1446">
                De $20K a $154K/mes en solo 4 meses. Esto es lo que pasa cuando
                aplicas la estrategia correcta.
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl" style={{
            boxShadow: '0 0 20px rgba(0, 247, 252, 0.1)'
          }} data-id="element-1447">
              <img src="https://cdn.magicpatterns.com/uploads/xwr3dSQ4TK8CGc5hG5nfVJ/Screenshot_2026-04-08_at_4.38.44_PM.png" alt="Crecimiento de ingresos — de $20K en Diciembre a $154,919 en Marzo" className="w-full h-auto block" data-id="element-1448" />
            </div>
          </div>
        </motion.section>

        {/* 5.5 CLIENT TESTIMONIALS */}
        <motion.section {...fadeIn} className="max-w-6xl mx-auto px-4 mb-24" data-id="element-1449">
          <div className="text-center mb-12" data-id="element-1450">
            <span className="bg-[#00f7fc]/10 text-[#00f7fc] border border-[#00f7fc]/20 px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-4 inline-block" data-id="element-1451">
              Resultados Reales
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1452">
              Lo Que Dicen Mis Clientes 1:1
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-1453">
              Todos estos clientes han generado más de 7 cifras con mi coaching.
              Escucha directamente de ellos — desliza para ver más →
            </p>
          </div>

          <div className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-2" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-1454">
            {/* David Moreno - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-1455">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1456">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-1457">
                  <iframe src="https://player.vimeo.com/video/1163771829?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="David Moreno Testimonial" data-id="element-1458" />
                </div>
                <div className="p-4" data-id="element-1459">
                  <p className="text-sm font-bold text-white" data-id="element-1460">David Moreno</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1461">
                    Cliente 1:1
                  </p>
                </div>
              </div>
            </div>

            {/* Richard & Laz - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-1462">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1463">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-1464">
                  <iframe src="https://player.vimeo.com/video/1163509676?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Richard & Laz Testimonial" data-id="element-1465" />
                </div>
                <div className="p-4" data-id="element-1466">
                  <p className="text-sm font-bold text-white" data-id="element-1467">Richard & Laz</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1468">
                    Clientes 1:1
                  </p>
                </div>
              </div>
            </div>

            {/* Carwin - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-1469">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1470">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-1471">
                  <iframe src="https://player.vimeo.com/video/1163416902?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Carwin Testimonial" data-id="element-1472" />
                </div>
                <div className="p-4" data-id="element-1473">
                  <p className="text-sm font-bold text-white" data-id="element-1474">Carwin</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1475">
                    Cliente 1:1
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Danel - Horizontal (16:9) - Below carousel */}
          <div className="max-w-3xl mx-auto mt-10" data-id="element-1476">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1477">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-1478">
                <iframe src="https://player.vimeo.com/video/1163511759?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Danel Testimonial en Entrevista" data-id="element-1479" />
              </div>
              <div className="p-4" data-id="element-1480">
                <p className="text-sm font-bold text-white" data-id="element-1481">Danel</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1482">
                  Cliente 1:1 — Entrevista
                </p>
              </div>
            </div>
          </div>

          {/* Santi - Horizontal (16:9) - Below Danel */}
          <div className="max-w-3xl mx-auto mt-6" data-id="element-1483">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1484">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-1485">
                <iframe src="https://player.vimeo.com/video/1181337901?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Santi Latest testimonio" data-id="element-1486" />
              </div>
              <div className="p-4" data-id="element-1487">
                <p className="text-sm font-bold text-white" data-id="element-1488">Santi</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1489">
                  Cliente 1:1
                </p>
              </div>
            </div>
          </div>
        </motion.section>

        {/* 6. QUALIFICATION SECTION */}
        <motion.section {...fadeIn} className="max-w-5xl mx-auto px-4 mb-24" data-id="element-1490">
          <div className="text-center mb-12" data-id="element-1491">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1492">
              ¿Es Para Ti?
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1493">
              Solo Trabajo Con Las Personas Correctas
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1494">
            {/* YES Column */}
            <div className="bg-emerald-900/10 border border-emerald-500/20 rounded-2xl p-8" data-id="element-1495">
              <h3 className="text-xl font-bold text-emerald-400 mb-8 flex items-center gap-3" data-id="element-1496">
                <CheckCircle className="w-6 h-6" data-id="element-1497" />
                Este coaching ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-1498">
                {[{
                t: 'Dueños de ecommerce',
                d: 'Que quieren escalar sus ventas con paid traffic y sistemas de retención.'
              }, {
                t: 'Creadores de productos digitales',
                d: 'Que quieren lanzar y vender con funnels de alta conversión.'
              }, {
                t: 'Emprendedores con oferta validada',
                d: 'Que quieren pasar de $10k a $100k/mes con estrategia y sistemas.'
              }, {
                t: 'Líderes de MLM',
                d: 'Que quieren construir su marca personal y reclutar digitalmente.'
              }, {
                t: 'Marcas DTC',
                d: 'Que quieren dominar Meta Ads y YouTube Ads para escalar agresivamente.'
              }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1499">
                    <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-1500" />
                    <div data-id="element-1501">
                      <p className="text-white font-bold text-sm mb-1" data-id="element-1502">
                        {item.t}
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1503">
                        {item.d}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>

            {/* NO Column */}
            <div className="bg-red-900/10 border border-red-500/20 rounded-2xl p-8" data-id="element-1504">
              <h3 className="text-xl font-bold text-red-400 mb-8 flex items-center gap-3" data-id="element-1505">
                <XCircle className="w-6 h-6" data-id="element-1506" />
                Este coaching NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-1507">
                {['Personas que buscan resultados sin invertir', 'Emprendedores que no están dispuestos a ejecutar', 'Quienes esperan resultados de la noche a la mañana', 'Personas sin capital para invertir en herramientas y ads'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1508">
                    <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-1509" />
                    <p className="text-gray-300 text-sm leading-relaxed" data-id="element-1510">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center max-w-2xl mx-auto" data-id="element-1511">
            <p className="text-gray-300 mb-8 text-lg" data-id="element-1512">
              Si te identificaste con el primer grupo, el siguiente paso es
              simple: escríbeme por WhatsApp y cuéntame sobre tu negocio.
            </p>
            <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-4 px-8 transition-all duration-300 transform hover:scale-[1.03] shadow-[0_0_20px_rgba(253,185,49,0.25)]" data-id="element-1513">
              <MessageCircle className="w-5 h-5" data-id="element-1514" />
              Quiero Hablar con Gabriel
            </a>
          </div>
        </motion.section>

        {/* 7. PROCESS SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 mb-24" data-id="element-1515">
          <div className="text-center mb-16" data-id="element-1516">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1517">
              El Proceso
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1518">
              Cómo Funciona el Coaching VIP 1:1
            </p>
          </div>

          <div className="space-y-12 relative before:absolute before:inset-0 before:ml-6 md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-[#00f7fc] before:via-[#00f7fc]/50 before:to-transparent" data-id="element-1519">
            {[{
            num: '01',
            icon: Search,
            title: 'Diagnóstico Profundo',
            desc: 'Analizamos tu negocio, tu oferta, tu tráfico y tus números. Identificamos los cuellos de botella exactos que están limitando tu crecimiento.'
          }, {
            num: '02',
            icon: FileText,
            title: 'Plan de Acción Personalizado',
            desc: 'Diseñamos una estrategia específica para tu situación. No hay plantillas genéricas — cada plan es único para tu modelo de negocio, tu mercado y tus objetivos.'
          }, {
            num: '03',
            icon: Rocket,
            title: 'Implementación y Seguimiento',
            desc: 'Trabajamos juntos en la ejecución. Tienes acceso directo a mí para preguntas, revisiones y ajustes en tiempo real mientras escalas.'
          }].map((step, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group" data-id="element-1520">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-black border-2 border-[#00f7fc] shadow-[0_0_15px_rgba(0,247,252,0.3)] shrink-0 md:order-1 md:group-odd:-ml-6 md:group-even:-mr-6 z-10" data-id="element-1521">
                  <step.icon className="w-5 h-5 text-[#00f7fc]" data-id="element-1522" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white/5 border border-white/10 p-6 rounded-2xl ml-6 md:ml-0 hover:border-[#00f7fc]/30 transition-colors" data-id="element-1523">
                  <span className="text-[#00f7fc] font-black text-xl mb-2 block" data-id="element-1524">
                    {step.num}
                  </span>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-1525">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1526">
                    {step.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.section>

        {/* 8. FAQ SECTION */}
        <motion.section {...fadeIn} className="max-w-3xl mx-auto px-4 mb-24" data-id="element-1527">
          <div className="text-center mb-12" data-id="element-1528">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1529">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1530">Lo Que Más Me Preguntan</p>
          </div>

          <div className="space-y-4" data-id="element-1531">
            {faqs.map((faq, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-id="element-1532">
                <button onClick={() => toggleFaq(i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-1533">
                  <span className="font-bold text-white pr-4" data-id="element-1534">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-[#00f7fc] transition-transform duration-300 shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-1535" />
                </button>
                <AnimatePresence data-id="element-1536">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-1537">
                      <div className="p-6 pt-0 text-gray-400 text-sm leading-relaxed border-t border-white/5 mt-2" data-id="element-1538">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.section>

        {/* 9. FINAL CTA SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 text-center" data-id="element-1539">
          <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 border border-[#00f7fc]/20 rounded-3xl p-10 md:p-16 relative overflow-hidden" data-id="element-1540">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-[#00f7fc]/10 blur-[100px] pointer-events-none" data-id="element-1541"></div>

            <div className="relative z-10" data-id="element-1542">
              <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-1543">
                ¿Listo Para Escalar?
              </h2>
              <p className="text-xl text-[#00f7fc] font-bold mb-6 uppercase tracking-wider" data-id="element-1544">
                El Próximo Paso Es Una Conversación
              </p>
              <p className="text-gray-400 text-lg mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-1545">
                Escríbeme por WhatsApp, cuéntame sobre tu negocio y tus
                objetivos. Si veo que puedo ayudarte, agendamos una llamada de
                diagnóstico sin costo.
              </p>

              <div className="w-full max-w-md mx-auto mb-6" data-id="element-1546">
                <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-5 px-6 transition-all duration-300 transform hover:scale-[1.03]" style={{
                boxShadow: '0 0 20px rgba(253, 185, 49, 0.25), 0 0 40px rgba(253, 185, 49, 0.1)'
              }} data-id="element-1547">
                  <span className="absolute inset-0 rounded-xl animate-pulse" style={{
                  boxShadow: '0 0 25px rgba(253, 185, 49, 0.35), 0 0 50px rgba(253, 185, 49, 0.15)'
                }} data-id="element-1548" />
                  <MessageCircle className="relative z-10 w-6 h-6" data-id="element-1549" />
                  <span className="relative z-10" data-id="element-1550">
                    Contáctame Ahora en WhatsApp
                  </span>
                  <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-1551">
                    <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] animate-shine" data-id="element-1552" />
                  </div>
                </a>
              </div>

              <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-gray-500 font-medium" data-id="element-1553">
                <CheckCircle className="w-4 h-4 text-emerald-500" data-id="element-1554" />
                <span data-id="element-1555">
                  Respuesta en menos de 24 horas · Sin compromiso · 100%
                  confidencial
                </span>
              </div>
            </div>
          </div>
        </motion.section>
      </main>

      <Footer data-id="element-1556" />
    </div>;
}